import React from 'react';
import { Text, Whitespace } from '../../components_new/common';
import Button from '../../components_new/common/FormComponents/Button';
import history from '../../core/history';

export default class VerifiedThanks extends React.Component {
  render() {
    const { isMobile } = this.props;
    return (
      <div className="f f-1 f-cc f-rows">
        <div className="f f-cc f-rows">
          <Text h4>Email confirmed!</Text>
          <Whitespace small />
          <Text>Your email is confirmed and you're ready to roll!</Text>
          <Whitespace small />
          {!isMobile && (
            <Button primary action onClick={() => history.push('/login')}>
              Login
            </Button>
          )}
          <Whitespace small />
          {isMobile && (
            <a href="yoodlize://">
              <Button primary action>
                Back to App
              </Button>
            </a>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/trustAndVerification/VerifiedThanks.js